import React from 'react';
import { FiClock } from 'react-icons/fi';
import { WidgetDef, GENERATE_NOTE } from '../types';
import { DemoHead, DemoSearch, DocList, DocItem } from '../shared';

// spec 622:4776
const ITEMS: (DocItem & { info: string })[] = [
    { title: 'Notice of Annual General Meeting 2026', meta: '19 Jul 2026', info: '24 pages · 2.4 MB', badge: 'Notice', likes: 9, questions: 1 },
    { title: 'Proxy Form 2026', meta: '19 Jul 2026', info: '2 pages · 2.4 MB', badge: 'Proxy', likes: 5, questions: 0 },
    { title: 'Results of the 2025 AGM', meta: '20 Nov 2025', info: '3 pages · 2.4 MB', badge: 'Results', likes: 3, questions: 0 },
];

const noticeOfMeetings: WidgetDef = {
    slug: 'notice-of-meetings',
    name: 'Notice of meetings',
    description: 'AGM and general meeting notices',
    icon: <FiClock />,
    title: 'Notice of Meetings Widget',
    installed: false,
    page: null,
    expectedPage: '/investors/meetings/',
    mustInstall: true,
    views: null,
    savedCodes: [
        { path: '/investors/investors-dashboard/', note: 'Next meeting only' },
        { path: '/investors/meetings/', note: 'Full list' },
    ],
    demoPath: '/investors/',
    addNote: 'This code is generated from the settings below. Change a setting and the code updates — paste it once, it stays current.',
    addBlocks: [
        { title: '1 · WordPress shortcode', code: '[investi_meetings instance="notices"]' },
        { title: '2 · Or plain HTML', code: '<div data-investi-instance="notices" data-investi="meetings"></div>', dark: true },
    ],
    settings: [
        { kind: 'heading', label: 'Widget style' },
        { kind: 'segmented', key: 'style', options: ['List', 'Tabs', 'Accordion by year', 'Carousel'], default: 'List' },
        { kind: 'heading', label: 'What visitors can do' },
        { kind: 'toggle', key: 'search', label: 'Search box', hint: 'Search by title', default: true },
        { kind: 'toggle', key: 'filterYear', label: 'Filter by year', default: true },
        { kind: 'heading', label: 'What it shows' },
        { kind: 'toggle', key: 'nextMeeting', label: 'Show the next meeting at the top', default: true },
        { kind: 'toggle', key: 'likes', label: 'Let visitors like a document', hint: 'A like button on every row', default: true },
        { kind: 'toggle', key: 'likeCount', label: 'Show the like count', default: true },
        { kind: 'toggle', key: 'questionCount', label: 'Show the question count', default: true },
        { kind: 'toggle', key: 'questions', label: 'Show the questions section', hint: 'The ask box and published answers', default: true },
        { kind: 'toggle', key: 'fileInfo', label: 'Show the file size and page count', default: true },
        { kind: 'note', text: 'Likes and questions need a signed‑in investor or an email address, so the numbers are real people, not clicks. They appear in Communications › Announcements alongside the announcement.' },
    ],
    generateNote: GENERATE_NOTE,
    Demo: ({ settings: s }) => {
        const items = ITEMS.map(({ info, ...i }) => ({ ...i, meta: s.fileInfo ? `${i.meta} · ${info}` : i.meta }));
        return <>
            <DemoHead title="Meetings" sub="Notices, proxy forms and results" />
            <DemoSearch placeholder="Search meetings…" showSearch={!!s.search} filters={s.filterYear ? ['Year: All'] : []} />
            <DocList items={items} likes={!!s.likes} likeCount={!!s.likeCount} questionCount={!!s.questionCount} />
        </>;
    },
};

export default noticeOfMeetings;
